<template>
  <el-dialog
    title="备件领用审批配置"
    :visible.sync="visible"
    width="760px"
    append-to-body
    :close-on-click-modal="false"
    :z-index="3010"
  >
    <el-form ref="configFormRef" :model="configForm" label-width="120px" size="small">
      <el-form-item label="审批时限">
        <el-input-number
          v-model="configForm.approvalLimitHours"
          :min="1"
          :precision="0"
          :step="1"
          controls-position="right"
        />
        <span style="margin-left: 8px; color: #909399">小时</span>
      </el-form-item>
      <el-form-item label="库房管理部门">
        <el-cascader
          v-model="configForm.warehouseDeptPath"
          :options="deptTree"
          :props="deptProps"
          filterable
          clearable
          style="width: 100%"
          @change="onWarehouseDeptChange"
        />
      </el-form-item>
      <div class="detail-toolbar">
        <span class="detail-label">多级审批节点</span>
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="addConfigNode">新增节点</el-button>
      </div>
      <el-table :data="configForm.nodeList" border size="small" style="width: 100%">
        <el-table-column label="顺序" width="70" align="center">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column label="节点名称" min-width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.nodeName" maxlength="128" size="mini" />
          </template>
        </el-table-column>
        <el-table-column label="审批部门" min-width="220">
          <template slot-scope="scope">
            <el-cascader
              v-model="scope.row.deptPath"
              :options="deptTree"
              :props="deptProps"
              filterable
              clearable
              style="width: 100%"
              size="mini"
              @change="(val) => onNodeDeptChange(scope.row, val)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" :disabled="scope.$index === 0" @click="moveConfigNode(scope.$index, -1)">上移</el-button>
            <el-button type="text" size="mini" :disabled="scope.$index === configForm.nodeList.length - 1" @click="moveConfigNode(scope.$index, 1)">下移</el-button>
            <el-button type="text" size="mini" style="color: #f56c6c" @click="removeConfigNode(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="submitFlowConfig">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getDeptTree } from '@/api/system/dept'
import { getFlowConfig, saveFlowConfig } from '../api'

export default {
  name: 'ApplyFlowConfigDialog',
  data() {
    return {
      visible: false,
      submitting: false,
      deptTree: [],
      deptProps: {
        value: 'id',
        label: 'title',
        children: 'children',
        checkStrictly: true,
        emitPath: true,
      },
      configForm: {
        approvalLimitHours: 24,
        warehouseDeptId: null,
        warehouseDeptName: '',
        warehouseDeptPath: [],
        nodeList: [],
      },
    }
  },
  methods: {
    async open() {
      await this.loadDeptTree()
      const res = await getFlowConfig()
      const dto = res && res.data && res.data.data
      const warehouseDeptPath = dto && dto.warehouseDeptId
        ? this.findDeptPathById(this.deptTree, dto.warehouseDeptId)
        : []
      this.configForm = {
        approvalLimitHours: (dto && dto.approvalLimitHours) || 24,
        warehouseDeptId: dto && dto.warehouseDeptId,
        warehouseDeptName: (dto && dto.warehouseDeptName) || '',
        warehouseDeptPath,
        nodeList: ((dto && dto.nodeList) || []).map((node, index) => ({
          nodeSort: index + 1,
          nodeName: node.nodeName || `第${index + 1}级审批`,
          approvalDeptId: node.approvalDeptId,
          approvalDeptName: node.approvalDeptName,
          deptPath: node.approvalDeptId ? this.findDeptPathById(this.deptTree, node.approvalDeptId) : [],
        })),
      }
      if (!this.configForm.nodeList.length) {
        this.addConfigNode()
      }
      this.visible = true
    },
    async loadDeptTree() {
      if (this.deptTree.length) return
      const res = await getDeptTree()
      const data = res && res.data && res.data.data
      this.deptTree = this.normalizeDeptTree(Array.isArray(data) ? data : [])
    },
    normalizeDeptTree(list) {
      return (list || []).map((item) => {
        const id = item.id != null ? item.id : item.value
        const title = item.title || item.label || item.deptName || item.name || ''
        return {
          ...item,
          id,
          title,
          children: this.normalizeDeptTree(item.children || []),
        }
      })
    },
    findDeptNode(options, id) {
      if (id == null) return null
      for (let i = 0; i < options.length; i++) {
        const item = options[i]
        if (String(item.id) === String(id) || String(item.value) === String(id)) {
          return item
        }
        const found = this.findDeptNode(item.children || [], id)
        if (found) return found
      }
      return null
    },
    findDeptPathById(options, id, path = []) {
      if (id == null) return []
      for (let i = 0; i < options.length; i++) {
        const item = options[i]
        const currentPath = path.concat(item.id)
        if (String(item.id) === String(id) || String(item.value) === String(id)) {
          return currentPath
        }
        const found = this.findDeptPathById(item.children || [], id, currentPath)
        if (found.length) return found
      }
      return []
    },
    onWarehouseDeptChange(val) {
      const selectedId = val && val.length ? val[val.length - 1] : null
      const dept = this.findDeptNode(this.deptTree, selectedId)
      this.configForm.warehouseDeptId = selectedId
      this.configForm.warehouseDeptName = dept ? dept.title || dept.label || dept.deptName : ''
    },
    onNodeDeptChange(row, val) {
      const selectedId = val && val.length ? val[val.length - 1] : null
      const dept = this.findDeptNode(this.deptTree, selectedId)
      row.approvalDeptId = selectedId
      row.approvalDeptName = dept ? dept.title || dept.label || dept.deptName : ''
    },
    addConfigNode() {
      const next = this.configForm.nodeList.length + 1
      this.configForm.nodeList.push({
        nodeSort: next,
        nodeName: `第${next}级审批`,
        approvalDeptId: null,
        approvalDeptName: '',
        deptPath: [],
      })
    },
    removeConfigNode(index) {
      this.configForm.nodeList.splice(index, 1)
      this.configForm.nodeList.forEach((node, idx) => {
        node.nodeSort = idx + 1
        if (!node.nodeName) node.nodeName = `第${idx + 1}级审批`
      })
    },
    moveConfigNode(index, direction) {
      const target = index + direction
      if (target < 0 || target >= this.configForm.nodeList.length) return
      const list = this.configForm.nodeList
      const current = list.splice(index, 1)[0]
      list.splice(target, 0, current)
      list.forEach((node, idx) => {
        node.nodeSort = idx + 1
      })
    },
    async submitFlowConfig() {
      if (!this.configForm.approvalLimitHours || this.configForm.approvalLimitHours < 1) {
        this.$message.warning('审批时限必须大于 0 小时')
        return
      }
      if (!this.configForm.warehouseDeptId) {
        this.$message.warning('请选择库房管理部门')
        return
      }
      if (!this.configForm.nodeList.length) {
        this.$message.warning('请至少配置一级审批节点')
        return
      }
      for (let i = 0; i < this.configForm.nodeList.length; i++) {
        if (!this.configForm.nodeList[i].approvalDeptId) {
          this.$message.warning(`请选择第 ${i + 1} 级审批部门`)
          return
        }
      }
      this.submitting = true
      try {
        const payload = {
          approvalLimitHours: this.configForm.approvalLimitHours,
          warehouseDeptId: this.configForm.warehouseDeptId,
          warehouseDeptName: this.configForm.warehouseDeptName,
          nodeList: this.configForm.nodeList.map((node, index) => ({
            nodeSort: index + 1,
            nodeName: node.nodeName || `第${index + 1}级审批`,
            approvalDeptId: node.approvalDeptId,
            approvalDeptName: node.approvalDeptName,
          })),
        }
        const res = await saveFlowConfig(payload)
        const body = res && res.data
        if (body && body.success && (body.code === 200 || body.code === 2000)) {
          this.$message.success('审批配置已保存')
          this.visible = false
          this.$emit('success')
        } else {
          this.$message.error((body && body.msg) || '保存失败')
        }
      } finally {
        this.submitting = false
      }
    },
  },
}
</script>
